import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "E:/Web/react-nails/react-nails-docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img alt="logo" src={require("../../img/react-nails-logo.png")} /></p>
    <p>{`React-nails is an easy to use UI-kit to provide fast, homogeneous, responsive and consistent web application frontends. It has out-of-the-box theming capabilities.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      